import AgentInfoCard from "components/AgentPortal/PolicyDetails/PolicyCards/AgentInfoCard";
import BeneficiariesCard from "components/AgentPortal/PolicyDetails/PolicyCards/BeneficiariesCard";
import CoverageAndDocuments from "components/AgentPortal/PolicyDetails/PolicyCards/CoverageAndDocuments";
import FinancialsCard from "components/AgentPortal/PolicyDetails/PolicyCards/FinancialsCard";
import OwnerAndInsuredCard from "components/AgentPortal/PolicyDetails/PolicyCards/OwnerAndInsuredCard";
import PaymentSummaryCard from "components/AgentPortal/PolicyDetails/PolicyCards/PaymentSummaryCard";
import AgentSendReminderModal from "components/AgentPortal/ModalDialogs/AgentSendReminderModal";
import { useState } from "react";
import {
  isInterestSensitiveWholeLifePolicy,
  isMITPolicy,
  isPolicyInactiveByPolicyStatus,
} from "js/utilities";

const SinglePolicyView = ({ policy, policyDetail, filteredDocuments }) => {
  const [isOpenSendReminder, setIsOpenSendReminder] = useState(false);

  return (
    <>
      <div className="grid grid-cols-1 gap-4 xl:gap-6">
        {/* Coverage and Documents Card */}
        <CoverageAndDocuments
          policy={policy}
          policyDetail={policyDetail}
          isOpenSendReminder={isOpenSendReminder}
          setIsOpenSendReminder={setIsOpenSendReminder}
          filteredDocuments={filteredDocuments}
        />
        {/* Financials Card */}
        {!isMITPolicy(policy) && (
          <FinancialsCard policy={policy} policyDetail={policyDetail} />
        )}
        {/* Owner and Insured Card */}
        <OwnerAndInsuredCard
          policy={policy}
          policyDetail={policyDetail}
          isOpenSendReminder={isOpenSendReminder}
          setIsOpenSendReminder={setIsOpenSendReminder}
        />
        {/* Beneficiaries card */}
        <BeneficiariesCard policyDetail={policyDetail} />

        {/* Payment summary card */}
        {!isInterestSensitiveWholeLifePolicy(policyDetail) &&
          !isPolicyInactiveByPolicyStatus(policyDetail?.status) &&
          !["reducedpaidup", "paid-up", "extended term"].includes(
            (policyDetail?.status || "").toLowerCase()
          ) && (
            <PaymentSummaryCard
              policyDetail={policyDetail}
              isOpenSendReminder={isOpenSendReminder}
              setIsOpenSendReminder={setIsOpenSendReminder}
            />
          )}

        {/* Agent information */}
        <AgentInfoCard policy={policy} policyDetail={policyDetail} />
      </div>

      {/* Send customer a reminder Dialog */}
      <AgentSendReminderModal
        isOpenSendReminder={isOpenSendReminder}
        setIsOpenSendReminder={setIsOpenSendReminder}
      />
    </>
  );
};

export default SinglePolicyView;
